import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import styles from './index.css';

export class Info extends React.Component {
    render() {
        return (
            <Grid container justify="space-between" spacing={2}>
                <Grid item>
                    <Typography className={styles.header}>{this.props.label}</Typography>
                </Grid>
                <Grid item xs>
                    <Typography className={styles.content} component="div" title={this.props.contentTitle}>{this.props.children}</Typography>
                </Grid>
            </Grid>
        )
    }
}
